module.exports = __webpack_public_path__ + "img/CommandsVideo.ab0c86d9.png";